<template>
  <div>

            <v-row no-gutters>
              <v-col cols="6" class="headline text--primary">
                <span v-if="bussYr >= 2026 && $store.state.documentActiv === 'InvoiceSales'">{{document.TipDokumenta}} </span>
                <span v-if="$store.state.documentActiv !== 'InvoiceSales'">{{documentNameLoc}} {{langC.Number}}: </span>
              </v-col>
              <v-col cols="6">
                <div class="headline text--primary">
                  {{document.documentId}}, {{locdocumentDate}}, {{exportDoc}}
                </div>
              </v-col>
            </v-row>

             <v-row no-gutters v-if="bussYr >= 2026 && $store.state.documentActiv === 'InvoiceSales'">
              <v-col cols="12">
               <span v-if="document.eRacunPoslovniProcesSifra === 'P9' || document.eRacunPoslovniProcesSifra === 'P10'" style="color:red">{{document.eRacunPoslovniProces}} </span>
               <span v-if="document.eRacunPoslovniProcesSifra === 'P9' || document.eRacunPoslovniProcesSifra === 'P10'"><br>Referenca na:{{document.RefNaPrethodniRacun}}, {{document.RefNaPrethodniRacunDatum}}</span>
               <span v-if="document.eRacunPoslovniProcesSifra !== 'P9' && document.eRacunPoslovniProcesSifra !== 'P10'" style="color:green ">{{document.eRacunPoslovniProces}} </span>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3">
                <small>{{lang.User}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{document.First}} {{document.Last}}, {{document.email}}</span></small>
              </v-col>
            </v-row>

            <v-row no-gutters v-if="connTxt">
              <v-col cols="3">
                  <small><span v-if="this.$store.state.language == 'EN'">
                    Connection:
                   </span>
                   <span v-if="this.$store.state.language == 'HR'">
                    Veza:
                   </span></small>
              </v-col>
              <v-col cols="8">
                  <span style="font-weight:bold">{{connTxt}}</span>
              </v-col>
            </v-row>

            <v-divider></v-divider>


            <v-row no-gutters v-if="document.documentDescription4">
              <v-col cols="3">
                <small>{{lang.Description4}}</small>
              </v-col>
              <v-col cols="8">
                  <span ><small>{{document.documentDescription4}}</small></span>
              </v-col>
            </v-row>

            <v-row no-gutters v-if="document.documentDescription1">
              <v-col cols="3">
                <small>{{lang.Description1}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{document.documentDescription1}}</span></small>
              </v-col>
            </v-row>  

            <v-row no-gutters v-if="document.documentDescription5">
              <v-col cols="3">
                <small>{{lang.Description5}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{document.documentDescription5}}</span></small>
              </v-col>
            </v-row>  

            <v-row no-gutters v-if="document.documentDescription3">
              <v-col cols="3">
                <small>{{lang.Description3}}</small>
              </v-col>
              <v-col cols="8">
                <small><span >{{document.documentDescription3}}</span></small>
              </v-col>
            </v-row>             

            <v-divider></v-divider>

            <v-row no-gutters v-if="$store.state.documentActiv === 'InvoiceSales' ">
              <v-col cols="3">
                <small>{{lang.DeadLine}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{datesInvoice}}</span></small>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3">
                <small>{{langC.CreatedAt}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{locCreatedAt}}</span></small>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3">
                <small>{{langC.UpdatedAt}}</small>
              </v-col>
              <v-col cols="8">
                  <small><span >{{locUpdatedAt}}</span></small>
              </v-col>
            </v-row>
  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'
import dateFormat from '@/snippets/dateFormat'

export default {
  data() {
    return {
      document: {},
      locCreatedAt: '',
      locUpdatedAt: '',
      lang: {},
      langC: {},
      documentNameLoc: '',
      locdocumentDate: '',
      exportDoc: '',
      connTxt: '',
      bussYr: 2026,
      txtColor: 'green',
      datesInvoice: null,
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
      this.exportDoc = this.$store.state.documentActivHead.exportDoc ? ' EXPORT' : ''
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
      this.exportDoc = this.$store.state.documentActivHead.exportDoc ? ' IZVOZ' : '' 
    }
    if (this.$store.state.documentActivHead) {
      this.document = this.$store.state.documentActivHead
      this.documentNameLoc = this.$store.state.documentActivLoc
      this.bussYr = this.document && this.document.BusinessYear ? this.document.BusinessYear : 2026
     
      if (this.document.documentDate) {
          this.locdocumentDate = dayjs(this.document.documentDate).format('DD.MM.YYYY')
      }
      this.locCreatedAt = dayjs(this.document.createdAt).format('DD.MM.YYYY HH:MM')
      this.locUpdatedAt = dayjs(this.document.updatedAt).format('DD.MM.YYYY HH:MM') + (this.document.LastUpdateBy ? ', ' + this.document.LastUpdateBy : '')
      this.connTxt =  (this.document.documentConnName ? this.document.documentConnName + ':' : '') + (this.document.documentConnId ? this.document.documentConnId + '/' : '') + (this.document.documentConnDate ? dayjs(this.document.documentConnDate).format('DD.MM.YYYY HH:MM') : '')
      const dOne = dayjs(this.document.documentInvoiceEndDate).format('DD.MM.YYYY')
      const dTwo = this.document.documentInvoiceStartDate ? dayjs(this.document.documentInvoiceStartDate).format('DD.MM.YYYY') : ''
      const dThree = this.document.documentInvoiceEndPeriodDate ? dayjs(this.document.documentInvoiceEndPeriodDate).format('DD.MM.YYYY') : ''
      this.datesInvoice = dOne + ', Period: ' + dTwo + ' - ' + dThree

    }
  },
  methods: {
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
  } 
}
</script>

<style>

</style>